export default "__VITE_ASSET__4a6eba7f__"